<p-dialog [visible]="visible" [modal]="true"
  [breakpoints]="{ '1199px': '94vw', '786px': '100vw' }" [style]="{ width: '94vw' }"
  [draggable]="false" [resizable]="false" [closable]="false" styleClass="user-import-dialog">
  <ng-template pTemplate="header">
    <div class="text-xl font-semibold w-full pt-2">
      {{ "userAdministration.addUserToCompany" | translate }}
    </div>
  </ng-template>

  <gate-user-directory-company-table
    [companies]="companies"
    [isModuleAdmin]="isModuleAdmin"
    [selectable]="true"
    [showGroupSelection]="true"
    groupSelectionMode="multi"
    captionKey="userAdministration.allCompanies"
    addressHeaderKey="userAdministration.address"
    [selectedCompanies]="companySelected"
    [selectedGroups]="companySelectedGroups"
    emptyMessageKey="userAdministration.noImportableCompaniesFound"
    (toggleAllSelection)="toggleAllCompanies($event)"
    (companySelectionChange)="onCompanyCheckChange($event)"
    (groupSelectionChange)="onGroupSelectionChange($event.company, $event.selected)">
  </gate-user-directory-company-table>

  <ng-template pTemplate="footer">
    <div class="mt-4 flex justify-end gap-3">
      <p-button [label]="'cancelButton' | translate" severity="secondary"
        (onClick)="closeDialog()" [disabled]="isImporting" />
      <p-button [label]="'userAdministration.addSelectedUsersToCompanies' | translate: { count: selectedCompanyCount() }"
        [loading]="isImporting" [disabled]="!canImportUser()"
        (onClick)="importSelectedCompanies()" />
    </div>
  </ng-template>
</p-dialog>
